import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableLiveOrderRoutes = Loadable(
  './LiveOrderRoutes',
  () => import(/* webpackChunkName: "LiveOrder" */ './LiveOrderRoutes'),
  () => [(require as any).resolveWeak('./LiveOrderRoutes')]
);
